import _classCallCheck from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _createClass from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
import { createInterpolateValue } from '../utils';
import { Pow } from './pow';
import { d3Ticks } from '../tick-methods/d3-ticks';
export var Sqrt = /*#__PURE__*/function (_Pow) {
  _inherits(Sqrt, _Pow);
  _createClass(Sqrt, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        range: [0, 1],
        nice: false,
        clamp: false,
        round: false,
        interpolate: createInterpolateValue,
        tickMethod: d3Ticks,
        tickCount: 5,
        exponent: 0.5
      };
    }
  }]);
  function Sqrt(options) {
    _classCallCheck(this, Sqrt);
    return _possibleConstructorReturn(this, _getPrototypeOf(Sqrt).call(this, options));
  }
  _createClass(Sqrt, [{
    key: "update",
    value: function update(options) {
      _superPropGet(Sqrt, "update", this, 3)([options]);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Sqrt(this.options);
    }
  }]);
  return Sqrt;
}(Pow);